"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagPT = function FlagPT(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-44.7-122H-185.94a7.06,7.06,0,0,0-7.06,7.06V139.3a7.07,7.07,0,0,0,7.06,7.06H-44.7Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.86,12.18a63.5,63.5,0,0,1-63.5,63.5,63.51,63.51,0,0,1-63.51-63.5,63.51,63.51,0,0,1,63.51-63.5,63.5,63.5,0,0,1,63.5,63.5Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-23.45-9V19.24A21.21,21.21,0,0,1-44.64,40.43,21.21,21.21,0,0,1-65.83,19.24V-9h42.38m7.05-14.12H-72.89a7.06,7.06,0,0,0-7.06,7.06V19.24A35.31,35.31,0,0,0-44.64,54.55,35.31,35.31,0,0,0-9.33,19.24V-16.07a7.06,7.06,0,0,0-7.07-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-23.45-9V19.24A21.21,21.21,0,0,1-44.64,40.43,21.21,21.21,0,0,1-65.83,19.24V-9h42.38",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-69.41-16.07a3.53,3.53,0,0,1-3.54,3.53,3.53,3.53,0,0,1-3.53-3.53,3.53,3.53,0,0,1,3.53-3.53,3.53,3.53,0,0,1,3.54,3.53Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-12.92-16.07a3.53,3.53,0,0,1-3.53,3.53A3.53,3.53,0,0,1-20-16.07a3.53,3.53,0,0,1,3.53-3.53,3.53,3.53,0,0,1,3.53,3.53Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-69.41,12.18a3.53,3.53,0,0,1-3.54,3.53,3.53,3.53,0,0,1-3.53-3.53,3.53,3.53,0,0,1,3.53-3.53,3.53,3.53,0,0,1,3.54,3.53Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-12.92,12.18a3.53,3.53,0,0,1-3.53,3.53A3.53,3.53,0,0,1-20,12.18a3.53,3.53,0,0,1,3.53-3.53,3.53,3.53,0,0,1,3.53,3.53Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-41.16-16.07a3.54,3.54,0,0,1-3.54,3.53,3.53,3.53,0,0,1-3.53-3.53A3.53,3.53,0,0,1-44.7-19.6a3.54,3.54,0,0,1,3.54,3.53Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-20,38.22a3.53,3.53,0,0,1-3.53,3.53A3.53,3.53,0,0,1-27,38.22a3.53,3.53,0,0,1,3.53-3.53A3.53,3.53,0,0,1-20,38.22Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-61.95,38.22a3.53,3.53,0,0,1-3.53,3.53A3.53,3.53,0,0,1-69,38.22a3.53,3.53,0,0,1,3.53-3.53,3.53,3.53,0,0,1,3.53,3.53Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-40.08,10.39v6.08A4.56,4.56,0,0,1-44.64,21a4.56,4.56,0,0,1-4.56-4.56V10.39h9.12",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-40.08-4V2.05a4.56,4.56,0,0,1-4.56,4.56A4.56,4.56,0,0,1-49.2,2.05V-4h9.12",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-40.08,25V31a4.57,4.57,0,0,1-4.56,4.56A4.56,4.56,0,0,1-49.2,31V25h9.12",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-27.8,10.39v6.08A4.56,4.56,0,0,1-32.35,21a4.57,4.57,0,0,1-4.57-4.56V10.39h9.12",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-52.36,10.39v6.08A4.57,4.57,0,0,1-56.93,21a4.56,4.56,0,0,1-4.56-4.56V10.39h9.13",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagPT;
exports["default"] = _default;